



























































import { Component, Vue } from 'vue-property-decorator';
import AuthConnector from '@/connector/Auth.vue';
import DialogConnector from '@/connector/Dialog.vue';

@Component({
  components: {
    DialogConnector,
    AuthConnector,
  },
})
export default class SectionWelcome extends Vue {}
